// react
import React from 'react'

// hooks
import { useRetractSidebar } from '_hooks'

// components
import { TabbedViews, Form } from '@st-operations/uikit/src/v2/index.js'
import EntityEditForm from '_components/entity-edit-form/index.jsx'
import { booleanRule } from './boolean-rule'

// Styles
import './styles.scss'

// Segment ID Set page
//
// Metadata is editable, and so are the rules until the set mints its first ID -
// after that the API rejects the change, because a set holding IDs of two
// different shapes can't be read back by the partner.
//
// There is no backfill control: creating a set fills every taxonomy segment
// that already exists, and every segment created afterwards gets its id on
// creation, so there is nothing left for the user to trigger. The API keeps a
// backfill route as a recovery path.
const SegmentIdPage = (props) => {
  useRetractSidebar()

  return (
    <div id="segment-id-page">
      <EntityEditForm
        entities="taxonomy-id-sets"
        // the API resource and this page's route differ, so Exit, the back
        // arrow, and the post-save/delete redirects need to be told the route
        exitTo="/segment-ids"
        id={props.match.params.id}
        resource="Segment ID Set"
      >
        {({ disabled, item, onChange, schema }) => (
          <TabbedViews key={item._id}>
            <Form
              title="Metadata"
              item={item}
              onChange={onChange}
              schema={schema}
              // slug is deliberately absent: it is the mapping space key and
              // immutable once the set exists. It is shown in the list's
              // Mapping Space column instead.
              fields={[{ name: 'name' }, { name: 'description' }]}
              disabled={disabled}
            />

            <div title="Rules" className="segment-id-rules">
              <p className="segment-id-rules__note">
                These rules describe every ID this set generates. They can only be changed until the
                set has generated its first ID — after that a change would leave the set holding IDs
                of two different shapes.
              </p>

              <Form
                item={item}
                onChange={onChange}
                schema={schema}
                fields={[
                  booleanRule(
                    'starts_with_letter',
                    'Starts with a letter',
                    'First character is always a letter'
                  ),
                  booleanRule(
                    'alphanumeric',
                    'Alphanumeric',
                    item.alphanumeric ? 'Letters and digits' : 'Digits only'
                  ),
                  { name: 'size' },
                ]}
                disabled={disabled}
              />
            </div>
          </TabbedViews>
        )}
      </EntityEditForm>
    </div>
  )
}

// export
export default SegmentIdPage
